import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.product;
const productUrl = endpointNames.products.funeral;

// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

const getAllFuneralProducts = async (id) => {
    let response;
    //create configuration with token
    const config = {
        headers: {Authorization: `Bearer ${token}`}
    };
    await axios.get(baseUrl+'/'+id+'/packages', config)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });
    return response;
};

const addFuneralProducts = async(request) =>{
    let response;

    await axios.post(baseUrl+'sub/add-funeral-product',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

const addFuneralProductsReverse = async(request) =>{
    let response;

    await axios.post(baseUrl+'sub/add-funeral-product-reverse',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//delete
const deleteFuneralProduct = async(id) => {

    let response;
    await axios.delete(baseUrl+'sub/delete-funeral-product/'+id)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });
    return response;
}

//get single product
const getFuneralProductDetails = async (id) => {
    let response;
    await axios.get(baseUrl+'sub/get-funeral-product/'+id)
        .then(res => {
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//update product
const updateFuneralProduct = async (request) => {
    let response;
    await axios.put(baseUrl+'sub/edit-funeral-product',request)
        .then(res =>{
            console.log(res);
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

export default {
    getAllFuneralProducts,deleteFuneralProduct, addFuneralProducts,
    getFuneralProductDetails,updateFuneralProduct,addFuneralProductsReverse
}
